import { Box, Grid, Text } from '@approvalmax/ui/src/components';
import { FC, memo, useCallback } from 'react';
import { amplitudeService } from 'services/amplitude';

import { VideoPopup } from '../VideoPopup/VideoPopup';
import imgSrc from './assets/thumbnail.png';
import { getTitle, getVideoLink } from './IntroductionVideo.helpers';
import { IntroductionVideoProps } from './IntroductionVideo.types';

export const IntroductionVideo: FC<IntroductionVideoProps> = memo((props) => {
    const { companyId, profileId, integrationType } = props;

    const title = getTitle(integrationType);
    const videoSrc = getVideoLink(integrationType);

    const handleVideoOpen = useCallback(() => {
        amplitudeService.sendData('getting started: clicked on general video', {
            user_id: profileId,
            org_id: companyId,
        });
    }, [companyId, profileId]);

    return (
        <Box spacing='16 24' color='midnight20' radius='small'>
            <Text font='headline' fontSize='xxsmall' fontWeight='medium' spacing='0 0 16' color='midnight80'>
                {title}
            </Text>

            <Grid justifyContent='center'>
                <VideoPopup title={title} imgSrc={imgSrc} videoSrc={videoSrc} onOpen={handleVideoOpen} />
            </Grid>
        </Box>
    );
});

IntroductionVideo.displayName = 'IntroductionVideo';
